var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_recruit_job_posting",
          attrs: {
            id: "modal-recruit-job-posting",
            title: _vm.title,
            size: "xl",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-footer": ""
          },
          on: { hidden: _vm.onHidden }
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mt-2 mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "21%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "53%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "5%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "35%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "42%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "109%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "5%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { attrs: { "bg-variant": "light" } },
                                  [
                                    _c(
                                      "b-row",
                                      { staticClass: "align-items-end" },
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-recruit-task-id-select",
                                                  label: "Заявка на подбор"
                                                }
                                              },
                                              [
                                                _c("recruit-task-select", {
                                                  ref: "recruit_task_id_select",
                                                  attrs: {
                                                    size: "sm",
                                                    "is-disabled":
                                                      _vm.selectDisabled ||
                                                      _vm.isViewDisabled,
                                                    value:
                                                      _vm.newItem
                                                        .recruit_task_id
                                                  },
                                                  on: {
                                                    onSelect:
                                                      _vm.onRecruitTaskIdSelect,
                                                    onClear: _vm.onClearSelected
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-vacancy",
                                                  label: "Вакансия"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    size: "sm",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem
                                                        .location_vacancy_name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "location_vacancy_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.location_vacancy_name"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-location",
                                          label: "Объект"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.location_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "location_name",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.location_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-location-address",
                                          label: "Адрес объекта"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.location_address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "location_address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.location_address"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      { staticClass: "align-items-end" },
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-opened-date",
                                                  label:
                                                    "Дата открытия вакансии"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "date",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.opened_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "opened_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.opened_date"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-opened-date",
                                                  label:
                                                    "Дата первого выхода в смену"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    size: "sm",
                                                    type: "date",
                                                    disabled: _vm.isViewDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.closed_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "closed_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.closed_date"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-vacancy-text",
                                          label: "Текст вакансии"
                                        }
                                      },
                                      [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            rows: 3,
                                            resize: "",
                                            disabled: _vm.isViewDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.text,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "text", $$v)
                                            },
                                            expression: "newItem.text"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-organization",
                                          label: "Организация"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.newItem.organization_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "organization_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.organization_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-assigned",
                                          label: "Работодатель"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            disabled: _vm.isViewDisabled,
                                            options: _vm.assignedOptions
                                          },
                                          model: {
                                            value: _vm.newItem.assigned,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "assigned",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.assigned"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-status",
                                          label: "Статус"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            size: "sm",
                                            disabled: _vm.isViewDisabled,
                                            options: _vm.statusOptions
                                          },
                                          model: {
                                            value: _vm.newItem.status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "status",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.status"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  {
                                    staticClass: "h-100",
                                    attrs: {
                                      "bg-variant": "light",
                                      "body-class": "d-flex flex-column"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-provider-select",
                                          label: "Сервис"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            options: _vm.providerOptions,
                                            disabled: _vm.isViewDisabled
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "first",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: 0 } },
                                                    [_vm._v("Выберите сервис")]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ]),
                                          model: {
                                            value: _vm.newItem.provider_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "provider_id",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.provider_id"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-business-area-select",
                                          label: "Сфера деятельности"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-select",
                                          {
                                            attrs: {
                                              size: "sm",
                                              disabled:
                                                _vm.isViewDisabled ||
                                                !_vm.hasAvitoIntegration
                                            },
                                            model: {
                                              value:
                                                _vm.avitoData.business_area,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.avitoData,
                                                  "business_area",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "avitoData.business_area"
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { domProps: { value: null } },
                                              [
                                                _vm._v(
                                                  "Выберите сферу деятельности"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.avitoDictionaries,
                                              function(option) {
                                                return _c(
                                                  "option",
                                                  {
                                                    domProps: {
                                                      value: option.id
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(option.name) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-experience-select",
                                          label: "Опыт работы"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            options: _vm.experienceOptions,
                                            disabled: _vm.isViewDisabled
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "first",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: "" } },
                                                    [
                                                      _vm._v(
                                                        "Укажите опыт работы"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ]),
                                          model: {
                                            value: _vm.avitoData.experience,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.avitoData,
                                                "experience",
                                                $$v
                                              )
                                            },
                                            expression: "avitoData.experience"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-employment-select",
                                          label: "Занятость"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            options: _vm.employmentOptions,
                                            disabled: _vm.isViewDisabled
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "first",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: "" } },
                                                    [
                                                      _vm._v(
                                                        "Выберите вид занятости"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ]),
                                          model: {
                                            value: _vm.avitoData.employment,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.avitoData,
                                                "employment",
                                                $$v
                                              )
                                            },
                                            expression: "avitoData.employment"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-schedule-select",
                                          label: "График"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            type: "text",
                                            size: "sm",
                                            options: _vm.scheduleOptions,
                                            disabled: _vm.isViewDisabled
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "first",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    { attrs: { value: "" } },
                                                    [
                                                      _vm._v(
                                                        "Выберите график работы"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ]),
                                          model: {
                                            value: _vm.avitoData.schedule,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.avitoData,
                                                "schedule",
                                                $$v
                                              )
                                            },
                                            expression: "avitoData.schedule"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-salary-input",
                                          label: "Зарплата"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-3" },
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "number",
                                                    size: "sm",
                                                    placeholder: "От",
                                                    disabled: _vm.isViewDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.salary.from,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.salary,
                                                        "from",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.salary.from"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "number",
                                                    size: "sm",
                                                    placeholder: "До",
                                                    disabled: _vm.isViewDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.salary.to,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.salary,
                                                        "to",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.salary.to"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "Картинка" } },
                                          [
                                            _c("b-form-file", {
                                              ref: "avitoImgInput",
                                              attrs: {
                                                disabled:
                                                  _vm.isViewDisabled ||
                                                  _vm.loading,
                                                size: "sm",
                                                placeholder:
                                                  "Картинка не выбрана",
                                                "browse-text": "Выбрать",
                                                accept: "image/*"
                                              },
                                              on: { change: _vm.onFileChange }
                                            }),
                                            _vm._v(" "),
                                            _vm.avitoData.static_image_url
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _c("small", [
                                                      _vm._v("Загружено: "),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              _vm.avitoData
                                                                .static_image_url,
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.avitoData
                                                                .static_image_url
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-100 d-flex justify-content-end mt-auto"
                                      },
                                      [
                                        !_vm.hasAvitoIntegration &&
                                        !_vm.loading &&
                                        _vm.newItem.provider_id === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-danger m-0 py-1 px-2 mr-2 d-flex align-items-center",
                                                staticStyle: {
                                                  "font-size": "0.85rem",
                                                  "border-style": "dashed"
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "exclamation-triangle"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "У организации нет интеграции с Авито"
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "info",
                                              disabled:
                                                _vm.loading ||
                                                _vm.isViewDisabled ||
                                                !_vm.hasAvitoIntegration ||
                                                _vm.newItem.provider_id !== 1
                                            },
                                            on: { click: _vm.publishToAvito }
                                          },
                                          [
                                            _vm.loading
                                              ? _c("b-spinner", {
                                                  attrs: { small: "" }
                                                })
                                              : [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      icon:
                                                        _vm.avitoData &&
                                                        (_vm.avitoData
                                                          .vacancy_id ||
                                                          _vm.avitoData
                                                            .vacancy_uuid)
                                                          ? "arrow-alt-circle-up"
                                                          : "search-plus"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.avitoData &&
                                                          (_vm.avitoData
                                                            .vacancy_id ||
                                                            _vm.avitoData
                                                              .vacancy_uuid)
                                                          ? "Обновить объявление"
                                                          : "Опубликовать"
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "w-100 d-flex justify-content-end py-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "ml-auto mr-1",
                    attrs: { size: "sm", variant: "secondary" },
                    on: { click: _vm.hideModal }
                  },
                  [_vm._v("\n          Отменить\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: {
                      size: "sm",
                      variant: "success",
                      disabled: _vm.loading || _vm.isViewDisabled
                    },
                    on: { click: _vm.handleOk }
                  },
                  [
                    _vm.loading
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("font-awesome-icon", {
                      staticClass: "mr-1",
                      attrs: { icon: "save" }
                    }),
                    _vm._v("\n          Сохранить\n        ")
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b51d70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b51d70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitJobPosting.vue
// module id = null
// module chunks = 